import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { useTVStore, useVisibilityStore, useVODStore } from '@/shared/store'

import useVisibleContent from '@/pages/mainScreen/model/useVisibleContent'
import { useComponentsRender } from '@/app/context/ComponentsRenderContext/ComponentsRenderContext'
import { getFromLocalStorage } from '@/shared/localStorage/localStorageRepository'
import { IS_COOKIES_ACCEPTED } from '@/shared/constants'
import { shallow } from 'zustand/shallow'

export const useMainScreenLogic = () => {
    const { isComponentsReadyToRender } = useComponentsRender()
    const { setActualContentVisible } = useVisibleContent()
    const { pathname } = useLocation()
    const { isVodContentVisible, isTvContentVisible } = useVisibilityStore(
        (state) => ({
            isVodContentVisible: state.isVodContentVisible,
            isTvContentVisible: state.isTvContentVisible,
        }),
        shallow
    )
    const { isPIPMode, setSelectedChannel } = useTVStore(
        (state) => ({
            isPIPMode: state.isPIPMode,
            setSelectedChannel: state.setSelectedChannel,
        }),
        shallow
    )
    const { isVodContentPlaying } = useVODStore(
        (state) => ({
            isVodContentPlaying: state.isVodContentPlaying,
        }),
        shallow
    )

    const [openModal, setOpenModal] = useState(false)

    const handleClose = () => {
        setOpenModal(false)
    }

    useEffect(() => {
        setActualContentVisible(pathname)
    }, [isComponentsReadyToRender, pathname])

    useEffect(() => {
        setSelectedChannel(null)
        const isCookiesFromLocalStorage =
            getFromLocalStorage(IS_COOKIES_ACCEPTED)

        if (!isCookiesFromLocalStorage) {
            setOpenModal(true)
        }
    }, [])

    const isTVisible = isPIPMode ? true : isTvContentVisible

    return {
        openModal,
        handleClose,
        pathname,
        isComponentsReadyToRender,
        isTVisible,
        isVodContentVisible,
        isVodContentPlaying,
    }
}
